import React from 'react';
import { getCurrentLocale, strings } from '../../localization';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import fscreen from 'fscreen';
import { ACTIONS as dispatchActions } from 'APP_ROOT/data/layoutTemplateModularFullscreen/duck';
import { HISTORY_SELECTED_RESOURCE_TYPES } from '../../pages/History/History';

const RESIZE_EVENT_DISPATCH_INTERVAL_MS = 50;

// these constants correspond to variables declared at the top of layoutTemplateModularFullscreen.scss
const LEGACY_FONT_SIZE = 16;
const BASE_FONT_SIZE = 14;
const EXPANDED_ENHANCED_VIDEO_ACCESS_PANEL_HEIGHT = 130 + 6; // (130 height + (3 thick border * 2)) @ base font size
const LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT = 270 * (BASE_FONT_SIZE / LEGACY_FONT_SIZE);// + EXPANDED_ENHANCED_VIDEO_ACCESS_PANEL_HEIGHT; //RRW_ENHANCED
const LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT * 2;// - EXPANDED_ENHANCED_VIDEO_ACCESS_PANEL_HEIGHT;
const LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2 = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT * 3;// - (EXPANDED_ENHANCED_VIDEO_ACCESS_PANEL_HEIGHT * 2);
const LAYOUT_MAIN_MODULE_GROUP_SNAP_THRESHOLD = 20;
const LAYOUT_MAIN_NAVIGATION_HEADER_HEIGHT = 40 * (BASE_FONT_SIZE / LEGACY_FONT_SIZE);
const LAYOUT_MAIN_MODULE_GROUP_DETAILS_TAB_BAR_HEIGHT = LAYOUT_MAIN_NAVIGATION_HEADER_HEIGHT;
const LAYOUT_MAIN_MODULE_GROUP_DETAILS_DISCLOSURE_TAB_HEIGHT = 30 * (BASE_FONT_SIZE / LEGACY_FONT_SIZE);

const Z_INDEX_ABOVE = "3"; //1 isn't high enough for some elements in vehicle ResourceGroup content
const Z_INDEX_BENEATH = "2"; // reset/unset

export class MainModuleGroup extends React.PureComponent {

    static propTypes = {
        mainModuleGroup: PropTypes.node.isRequired, // typically the main component for the page
        legacyRenderWithoutNavigationMode: PropTypes.bool, // layout in a backwards compatible way for older basic pages that don't require navigation (Sign -In, -Up, etc etc)
        sessionManagerSelectedResourceResourceType: PropTypes.string, // allows for special styling cases when the MainNavigation selected menu RESOURCE_GROUP_TYPES differs from the sessionManager's selected resource 
        mainModuleGroupDetails: PropTypes.node, // a.k.a "Bottom Panel"
        mainModuleGroupDetailsEVAPanel: PropTypes.node, // a.k.a "Enhanced Video Access Panel"
        mainModuleGroupDetailsTitle: PropTypes.string,
        mainModuleGroupNavigation: PropTypes.node, // a.k.a "Left Panel"
        mainModuleGroupNavigationTitle: PropTypes.string,
        mainModuleGroupBackgroundColorOverride: PropTypes.string,
        className: PropTypes.string,
        // redux:
        mainNavigationIsCollapsed: PropTypes.bool.isRequired,
        mainModuleGroupNavigationIsCollapsed: PropTypes.bool.isRequired,
        setMainModuleGroupNavigation: PropTypes.func.isRequired,
        mainModuleGroupDetailsIsCollapsed: PropTypes.bool.isRequired,
        setMainModuleGroupDetails: PropTypes.func.isRequired,
        mainNavigationActiveMenuItemDomElementTop: PropTypes.number.isRequired,
        fullscreenModeIsActive: PropTypes.bool.isRequired
    }

    constructor(props) {

        super(props);

        const setDefaultPanelHeightFromSnapshot = this.props.fromSnapshot ? LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 : LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT;

        this.state = {
            mainModuleGroupNavigationZIndex: Z_INDEX_BENEATH,
            mainModuleGroupDetailsZIndex: Z_INDEX_ABOVE, // default is overlap mainModuleGroupNavigation, but 1 isn't high enough for some elements in vehicle ResourceGroup content
            mainModuleGroupDetailsIsDragging: false,
            mainModuleGroupDetailsResizableHeight: setDefaultPanelHeightFromSnapshot,
            mainModuleGroupDetailsResizableCollapsedBottom: undefined,
            displayFallbackFullscreenModeEscapeMessage: false, // displays a message for browser that don't support fullscreen which is similar to the 'esc' fullscreen message
            mapboxInteractionInProgress: false
        }
        this.mainModuleGroupRef = React.createRef();
        this.mainModuleGroupDetailsRef = React.createRef();
        this.displayFallbackFullscreenModeEscapeMessageTimeout = undefined;
        this.mainModuleGroupDetailsIsDraggingUpwards = false;
        this.onClickMapboxInteractionCheckTimeout = undefined;

        this.mainModuleGroupLastDragUpdateHeight = setDefaultPanelHeightFromSnapshot;
    }


    componentDidUpdate(prevProps, prevState) {

        if (this.props.sessionManagerSelectedResourceResourceType !== prevProps.sessionManagerSelectedResourceResourceType) {
            // reset detail panel's height customization properties and state when selecting a different resource type:
            this.mainModuleGroupDetailsIsDraggingUpwards = false;
            this.mainModuleGroupLastDragUpdateHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT
            this.setState({
                mainModuleGroupDetailsResizableHeight: LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT,
                mainModuleGroupDetailsResizableCollapsedBottom: undefined
            });
            return; // setState will trigger a subsequent componentDidUpdate where this condition will fall through and therefore continue below:
        }
        if ((prevProps.mainNavigationIsCollapsed !== this.props.mainNavigationIsCollapsed) ||
            (prevProps.fullscreenModeIsActive !== this.props.fullscreenModeIsActive)) {

            const interval = setInterval(() => {
                window.dispatchEvent(new Event('resize'))
            }, RESIZE_EVENT_DISPATCH_INTERVAL_MS); //horrible hacky solution for resizing map as panel animates out; but it works well so leaving it.
            setTimeout(() => {
                clearInterval(interval);
            }, 1000);
        }

        if (fscreen.fullscreenEnabled === false) { // 'fullscreenEnabled' means native browser fullscreen is supported/enabled (doesn't mean it's actively fullscreened)
            // SAFARI has a conflict in that it supports fullscreen and it DOESN'T show this message. Plus, detecting Safari is not foolproof (https://stackoverflow.com/a/23522755)
            if (prevProps.fullscreenModeIsActive !== this.props.fullscreenModeIsActive) {

                if (this.displayFallbackFullscreenModeEscapeMessageTimeout) {
                    clearTimeout(this.displayFallbackFullscreenModeEscapeMessageTimeout);
                }
                if (this.props.fullscreenModeIsActive) {
                    this.displayFallbackFullscreenModeEscapeMessageTimeout = this.setState({ displayFallbackFullscreenModeEscapeMessage: true });
                    setTimeout(() => {
                        this.setState({ displayFallbackFullscreenModeEscapeMessage: false });
                    }, 5000);
                }
            }
        }

        if (prevProps.enhancedVideoAccessModeActive !== this.props.enhancedVideoAccessModeActive) {
            if (this.props.enhancedVideoAccessModeActive) {
                this.mainModuleGroupLastDragUpdateHeight += EXPANDED_ENHANCED_VIDEO_ACCESS_PANEL_HEIGHT;
            } else {
                this.mainModuleGroupLastDragUpdateHeight -= EXPANDED_ENHANCED_VIDEO_ACCESS_PANEL_HEIGHT;
            }
            this.finalizeSnapToPreset();
        }

    }

    setMainModuleGroupNavigationOnTop = () => {
        // fired on onClick and onScroll events
        // onScroll events fire multiple times a second; therefore relying on React optimizations for PureComponent/Memo to ignore redundant state updates
        // (I confirmed they were ignored by logging-out in `render()` and observing only 1 re-render during active scrolling)
        // if that optimization is already in place, then it didn't make sense to add another if-condition here (instead, I just set the state redundantly)
        this.setState({
            mainModuleGroupNavigationZIndex: Z_INDEX_ABOVE,
            mainModuleGroupDetailsZIndex: Z_INDEX_BENEATH
        });
    }
    setMainModuleGroupDetailsOnTop = () => {
        // fired on onClick and onScroll events
        // onScroll events fire multiple times a second; therefore relying on React optimizations for PureComponent/Memo to ignore redundant state updates
        // (I confirmed they were ignored by logging-out in `render()` and observing only 1 re-render during active scrolling)
        // if that optimization is already in place, then it didn't make sense to add another if-condition here (instead, I just set the state redundantly)
        this.setState({
            mainModuleGroupNavigationZIndex: Z_INDEX_BENEATH,
            mainModuleGroupDetailsZIndex: Z_INDEX_ABOVE
        });
    }

    toggleModuleGroupNavigation = () => {
        this.props.setMainModuleGroupNavigation(!this.props.mainModuleGroupNavigationIsCollapsed);
    }

    toggleMainModuleGroupDetails = () => {
        this.props.setMainModuleGroupDetails(!this.props.mainModuleGroupDetailsIsCollapsed);
    }

    onMainModuleGroupMouseMove = (event) => {

        if (this.state.mainModuleGroupDetailsIsDragging) {
            if (this.mainModuleGroupRef.current && this.mainModuleGroupDetailsRef.current) {

                const mainModuleGroupHeight = this.mainModuleGroupRef.current.offsetHeight;

                const pointerDistanceFromMainModuleGroupTop = event.clientY;

                let newHeight = mainModuleGroupHeight - pointerDistanceFromMainModuleGroupTop;

                let expandedFeaturesHeightAdjustment = 0;
                if (this.props.enhancedVideoAccessModeActive) {
                    expandedFeaturesHeightAdjustment = EXPANDED_ENHANCED_VIDEO_ACCESS_PANEL_HEIGHT;
                }


                if (this.state.mainModuleGroupDetailsResizableHeight < newHeight) {

                    this.mainModuleGroupDetailsIsDraggingUpwards = true;

                } else if (this.state.mainModuleGroupDetailsResizableHeight > newHeight) {

                    this.mainModuleGroupDetailsIsDraggingUpwards = false;

                }

                // enforce min and max heights:
                let minHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT + expandedFeaturesHeightAdjustment;
                if (this.props.sessionManagerSelectedResourceResourceType === HISTORY_SELECTED_RESOURCE_TYPES.HISTORY_CARD_DRIVING ||
                    this.props.sessionManagerSelectedResourceResourceType === HISTORY_SELECTED_RESOURCE_TYPES.HISTORY_CARD_PARKED) {
                    minHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT + expandedFeaturesHeightAdjustment;
                }

                if (Math.abs(LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment - newHeight) <= LAYOUT_MAIN_MODULE_GROUP_SNAP_THRESHOLD) {
                    newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment;
                }

                if (Math.abs(LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2 + expandedFeaturesHeightAdjustment - newHeight) <= LAYOUT_MAIN_MODULE_GROUP_SNAP_THRESHOLD) {
                    newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2 + expandedFeaturesHeightAdjustment;
                }

                /* restrict height to preset 2's max
                if (newHeight > LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2) {
                    newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2;
                }*/

                if (newHeight < minHeight) {
                    newHeight = minHeight;
                }
                // halt drag at max height available in viewport, if required
                if (newHeight > (mainModuleGroupHeight - LAYOUT_MAIN_NAVIGATION_HEADER_HEIGHT - LAYOUT_MAIN_MODULE_GROUP_DETAILS_TAB_BAR_HEIGHT - LAYOUT_MAIN_MODULE_GROUP_DETAILS_DISCLOSURE_TAB_HEIGHT - 1)) {
                    // the "-1" is to allow for one pixel of separation between the bottom of the main navigation header and the top of the details panel
                    newHeight = mainModuleGroupHeight - LAYOUT_MAIN_NAVIGATION_HEADER_HEIGHT - LAYOUT_MAIN_MODULE_GROUP_DETAILS_TAB_BAR_HEIGHT - LAYOUT_MAIN_MODULE_GROUP_DETAILS_DISCLOSURE_TAB_HEIGHT - 1;
                }



                this.mainModuleGroupLastDragUpdateHeight = newHeight;
                // update DOM element immediately
                this.mainModuleGroupDetailsRef.current.setAttribute("style", "z-index: " + this.state.mainModuleGroupDetailsZIndex + "; height: " + this.mainModuleGroupLastDragUpdateHeight + "px;");

                // only doing COSTLIER state updates while dragging if the change is significant enough
                // state and direct DOM updates are kept in finalizeSnapToPreset()
                if (Math.abs(this.mainModuleGroupLastDragUpdateHeight - this.state.mainModuleGroupDetailsResizableHeight) > 50) {
                    this.setState({
                        mainModuleGroupDetailsResizableHeight: newHeight,
                        mainModuleGroupDetailsResizableCollapsedBottom: 0 - newHeight - LAYOUT_MAIN_MODULE_GROUP_DETAILS_TAB_BAR_HEIGHT
                    });
                }
            }
        }
    }

    finalizeSnapToPreset = () => {

        let newHeight = this.mainModuleGroupLastDragUpdateHeight;// this.state.mainModuleGroupDetailsResizableHeight;

        if (this.mainModuleGroupDetailsDragHandleTimeoutMouseMightBeDragging) {

            // perform directional drag snap to next available preset based on dragging upwards or downwards

            let expandedFeaturesHeightAdjustment = 0;
            if (this.props.enhancedVideoAccessModeActive) {
                expandedFeaturesHeightAdjustment = EXPANDED_ENHANCED_VIDEO_ACCESS_PANEL_HEIGHT;
            }

            const distanceFromPreset1 = Math.abs(LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment - newHeight);
            const distanceFromDefault = Math.abs(LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT + expandedFeaturesHeightAdjustment - newHeight);

            const distanceBetweenDefaultAndPreset1 = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 - LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT; //  + expandedFeaturesHeightAdjustment cancelled out
            const distanceBetweenPreset1AndPreset2 = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2 - LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1; //  + expandedFeaturesHeightAdjustment cancelled out

            if (this.mainModuleGroupDetailsIsDraggingUpwards) {

                if (newHeight < LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2 + expandedFeaturesHeightAdjustment) {
                    if (newHeight > LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment) {
                        if ((distanceFromPreset1 / distanceBetweenPreset1AndPreset2) > 0.25) {
                            newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2 + expandedFeaturesHeightAdjustment;
                        } else {
                            newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment;
                        }

                    } else if (newHeight > LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT + expandedFeaturesHeightAdjustment) {
                        if ((distanceFromDefault / distanceBetweenDefaultAndPreset1) > 0.25) {
                            newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment;
                        } else {
                            newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT + expandedFeaturesHeightAdjustment;
                        }
                    }
                }
            } else {

                if (newHeight < LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment) {
                    if ((distanceFromDefault / distanceBetweenDefaultAndPreset1) > 0.75) {
                        newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment;
                    } else {
                        newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT + expandedFeaturesHeightAdjustment;
                    }
                } else if (newHeight < LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2 + expandedFeaturesHeightAdjustment) {
                    if ((distanceFromPreset1 / distanceBetweenPreset1AndPreset2) > 0.75) {
                        newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2 + expandedFeaturesHeightAdjustment;
                    } else {
                        newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment;
                    }
                } else {
                    newHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2 + expandedFeaturesHeightAdjustment;
                }
            }

        }

        const mainModuleGroupHeight = this.mainModuleGroupRef.current.offsetHeight;
        // halt drag or on-click height at max height available in viewport, if required
        if (newHeight > (mainModuleGroupHeight - LAYOUT_MAIN_NAVIGATION_HEADER_HEIGHT - LAYOUT_MAIN_MODULE_GROUP_DETAILS_TAB_BAR_HEIGHT - LAYOUT_MAIN_MODULE_GROUP_DETAILS_DISCLOSURE_TAB_HEIGHT - 1)) {
            // the "-1" is to allow for one pixel of separation between the bottom of the main navigation header and the top of the details panel
            newHeight = mainModuleGroupHeight - LAYOUT_MAIN_NAVIGATION_HEADER_HEIGHT - LAYOUT_MAIN_MODULE_GROUP_DETAILS_TAB_BAR_HEIGHT - LAYOUT_MAIN_MODULE_GROUP_DETAILS_DISCLOSURE_TAB_HEIGHT - 1;
        }

        this.setState({
            mainModuleGroupDetailsIsDragging: false,
            mainModuleGroupDetailsResizableHeight: newHeight,
            mainModuleGroupDetailsResizableCollapsedBottom: 0 - newHeight - LAYOUT_MAIN_MODULE_GROUP_DETAILS_TAB_BAR_HEIGHT
        });
        // sync DOM element directly (snapping can result in ignored/same state updates, so DOM element update ensures sync with known state)
        this.mainModuleGroupLastDragUpdateHeight = newHeight;
        if (this.mainModuleGroupDetailsRef && this.mainModuleGroupDetailsRef.current) {
            this.mainModuleGroupDetailsRef.current.style.height = this.mainModuleGroupLastDragUpdateHeight + "px";
        }
    }

    mainModuleGroupDetailsDragHandleTapHandler = (event) => {

        this.mainModuleGroupDetailsDragHandleTimeoutMouseMightBeDragging = false; // exclusive tap-event functionality will "take it from here" (esp. turn off percentage change directional drag snapping in finalizeSnapToPreset() / RAV-4032)

        let expandedFeaturesHeightAdjustment = 0;
        if (this.props.enhancedVideoAccessModeActive) {
            expandedFeaturesHeightAdjustment = EXPANDED_ENHANCED_VIDEO_ACCESS_PANEL_HEIGHT;
        }

        const mainModuleGroupHeight = this.mainModuleGroupRef.current.offsetHeight;
        const maxHeight = mainModuleGroupHeight - LAYOUT_MAIN_NAVIGATION_HEADER_HEIGHT - LAYOUT_MAIN_MODULE_GROUP_DETAILS_TAB_BAR_HEIGHT - LAYOUT_MAIN_MODULE_GROUP_DETAILS_DISCLOSURE_TAB_HEIGHT - 1;

        if (this.mainModuleGroupLastDragUpdateHeight <= LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT + expandedFeaturesHeightAdjustment) { // if default height, roughly

            this.mainModuleGroupLastDragUpdateHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment;

        } else if (this.mainModuleGroupLastDragUpdateHeight <= LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment) { // if preset 1 height, roughly

            if (this.mainModuleGroupLastDragUpdateHeight > maxHeight) {
                this.mainModuleGroupLastDragUpdateHeight = maxHeight;
            } else {
                this.mainModuleGroupLastDragUpdateHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2 + expandedFeaturesHeightAdjustment;
            }
        } else { // must be preset 2 or max height allowable
            this.mainModuleGroupLastDragUpdateHeight = LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT + expandedFeaturesHeightAdjustment;
        }
        this.finalizeSnapToPreset();
    }

    togglePanels(mainModuleGroupNavigationIsCollapsed, mainModuleGroupDetailsIsCollapsed) { // legacy support for dashboard
        this.props.setMainModuleGroupNavigation(mainModuleGroupNavigationIsCollapsed);
        this.props.setMainModuleGroupDetails(mainModuleGroupDetailsIsCollapsed);
    }

    onClickMapboxInteractionCheck = (event) => {

        const className = event.target ? event.target.className : undefined;
        if (className === "mapboxgl-ctrl-icon") { // matches standard mapbox controls: zoom in/out and map bearing controls 

            clearTimeout(this.onClickMapboxInteractionCheckTimeout);
            this.setState(
                { mapboxInteractionInProgress: true },
                () => {
                    setTimeout(() => {
                        this.setState({ mapboxInteractionInProgress: false })
                    }, 500);
                }
            );
            return;
        }
        if (className === "mapboxgl-canvas") { // a wheel event is like a zoom event, but setting the timeout a little longer to try to capture a typical manual scroll gesture duration
            clearTimeout(this.onClickMapboxInteractionCheckTimeout);
            this.setState(
                { mapboxInteractionInProgress: true },
                () => {
                    setTimeout(() => {
                        this.setState({ mapboxInteractionInProgress: false })
                    }, 1000);
                }
            );
        }
    }

    onMouseDownMapboxInteractionCheck = (event) => {

        const className = event.target ? event.target.className : undefined;
        if (!className || !className.startsWith) return; // className may be a SVGAnimatedString

        if (className.startsWith("mapboxgl")) {
            clearTimeout(this.onClickMapboxInteractionCheckTimeout);
            this.setState({ mapboxInteractionInProgress: true })
        }
    }

    onMouseUpMapboxInteractionCheck = () => {
        clearTimeout(this.onClickMapboxInteractionCheckTimeout);
        this.setState({ mapboxInteractionInProgress: false }); // redundant setStates are ignored (checking mapbox not necessary since end result is the same)
    }

    render() {

        let mainModuleGroupClass = "layout-main-module-group language-subtag-" + getCurrentLocale();

        if (!this.props.mainNavigationIsCollapsed) {
            if (!this.props.legacyRenderWithoutNavigationMode) {
                mainModuleGroupClass += " adjusted-for-main-navigation";
            }
        }
        if (this.props.legacyRenderWithoutNavigationMode) {
            mainModuleGroupClass += " legacy-render-without-navigation-mode";
        }

        let mainModuleGroupNavigationClass = "layout-main-module-group-navigation";
        let mainModuleGroupDetailsClass = "layout-main-module-group-details " + this.props.sessionManagerSelectedResourceResourceType;
        if (this.props.mainModuleGroupNavigationIsCollapsed) {
            mainModuleGroupNavigationClass += " collapsed";
        } else if (!this.props.mainModuleGroupDetailsIsCollapsed) {
            mainModuleGroupNavigationClass += " layout-main-module-group-details-may-collide";
        }

        if (this.props.mainModuleGroupDetailsIsCollapsed) {
            mainModuleGroupDetailsClass += " collapsed";
        }
        if (this.state.mainModuleGroupDetailsIsDragging) {
            mainModuleGroupDetailsClass += " dragging";
        }

        if (!this.props.mainNavigationIsCollapsed) {
            mainModuleGroupDetailsClass += " layout-main-navigation-is-expanded";
            mainModuleGroupNavigationClass += " layout-main-navigation-is-expanded";
        }

        if (this.props.fullscreenModeIsActive) {
            mainModuleGroupClass += " fullscreen-mode-is-active";
            mainModuleGroupDetailsClass += " fullscreen-mode-is-active";
            mainModuleGroupNavigationClass += " fullscreen-mode-is-active";
        }

        let expandedFeaturesHeightAdjustment = 0;
        if (this.props.enhancedVideoAccessModeActive) {
            mainModuleGroupDetailsClass += " enhanced-video-access-mode-active";
            expandedFeaturesHeightAdjustment = EXPANDED_ENHANCED_VIDEO_ACCESS_PANEL_HEIGHT;
        }

        const thresholdForSwitchFromPreset1To2 = (LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_2 - LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1) * 0.25; // 25 percent

        let mainModuleGroupDetailsDynamicStyles = {
            zIndex: this.state.mainModuleGroupDetailsZIndex,
        };

        if (this.state.mainModuleGroupDetailsResizableHeight) { // only set when customized, reset when switching resource types

            if (this.state.mainModuleGroupDetailsResizableHeight >= LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_PRESET_1 + expandedFeaturesHeightAdjustment + thresholdForSwitchFromPreset1To2) {
                mainModuleGroupDetailsClass += " layout-main-module-group-details-height-trip-report-preset-2";
            } else if (this.state.mainModuleGroupDetailsResizableHeight > LAYOUT_MAIN_MODULE_GROUP_DETAILS_HEIGHT_TRIP_REPORT_DEFAULT + expandedFeaturesHeightAdjustment) {
                mainModuleGroupDetailsClass += " layout-main-module-group-details-height-trip-report-preset-1";
            } else {
                mainModuleGroupDetailsClass += " layout-main-module-group-details-height-trip-report-preset-default";
            }

            mainModuleGroupDetailsDynamicStyles.height = this.state.mainModuleGroupDetailsResizableHeight + "px";
        }

        if (this.state.mainModuleGroupDetailsResizableCollapsedBottom !== undefined) {
            if (this.props.mainModuleGroupDetailsIsCollapsed) {
                mainModuleGroupDetailsDynamicStyles.bottom = this.state.mainModuleGroupDetailsResizableCollapsedBottom + "px";
            }
        }

        const styleOverrides = this.props.mainModuleGroupBackgroundColorOverride ? { backgroundColor: this.props.mainModuleGroupBackgroundColorOverride } : null;

        let mainModuleGroupNavigationDomElementTop = 0;
        if (!this.props.mainNavigationIsCollapsed && this.props.mainModuleGroupNavigationIsCollapsed) {
            mainModuleGroupNavigationDomElementTop = this.props.mainNavigationActiveMenuItemDomElementTop;
        }

        const mainModuleGroupNavigationDynamicStyles = {
            zIndex: this.state.mainModuleGroupNavigationZIndex,
            top: mainModuleGroupNavigationDomElementTop
        };

        let layoutTemplateModularFullscreen = "layout-template-modular-fullscreen";
        if (this.state.mainModuleGroupDetailsIsDragging || this.state.mapboxInteractionInProgress) {
            layoutTemplateModularFullscreen += " dragging";
        }
        if (this.props.className) {
            layoutTemplateModularFullscreen += ` ${this.props.className}`;
        }

        return (
            <div
                className={layoutTemplateModularFullscreen}
                ref={this.mainModuleGroupRef}
                style={styleOverrides}
                onMouseUp={this.finalizeSnapToPreset}
                // conditionally adding mouse movement event listeners (RAV-3566):
                onMouseMove={this.state.mainModuleGroupDetailsIsDragging ? this.onMainModuleGroupMouseMove : undefined}
                onMouseLeave={this.state.mainModuleGroupDetailsIsDragging ? this.finalizeSnapToPreset : undefined}
            >

                <main
                    className={mainModuleGroupClass}
                    onClick={this.onClickMapboxInteractionCheck}
                    onWheel={this.onClickMapboxInteractionCheck}
                    onMouseDown={this.onMouseDownMapboxInteractionCheck}
                    onMouseUp={this.onMouseUpMapboxInteractionCheck}
                    onMouseEnter={this.onMouseUpMapboxInteractionCheck}
                >

                    {this.props.mainModuleGroup}
                </main>

                {this.props.fullscreenModeIsActive && (fscreen.fullscreenEnabled === false) ?  // 'fullscreenEnabled' means native browser fullscreen is supported/enabled (doesn't mean it's actively fullscreened)
                    <div className={this.state.displayFallbackFullscreenModeEscapeMessage ? "layout-template-modular-fullscreen-escape-message visible" : "layout-template-modular-fullscreen-escape-message"}>
                        {strings.map_controls_press_escape_to_exit_fullscreen}
                    </div>
                    :
                    null
                }
                {this.props.mainModuleGroupDetails ?
                    <section ref={this.mainModuleGroupDetailsRef} onClick={this.setMainModuleGroupDetailsOnTop} onScroll={this.setMainModuleGroupDetailsOnTop} className={mainModuleGroupDetailsClass} style={mainModuleGroupDetailsDynamicStyles}>
                        <div className="layout-main-module-group-details-tab-bar">
                            <button className="layout-main-module-group-details-disclosure-tab" onClick={this.toggleMainModuleGroupDetails} >
                                <i className="material-icons">keyboard_arrow_down</i>
                            </button>
                            {this.props.mainModuleGroupDetailsTitle ?
                                <header>{this.props.mainModuleGroupDetailsTitle}</header>
                                :
                                null
                            }
                            {this.props.mainModuleGroupDetailsIsCollapsed ?
                                null
                                :
                                <button className="layout-main-module-group-drag-handle"
                                    /* onClick={this.mainModuleGroupDetailsDragHandleTapHandler} DON'T USE (clicks and drags differentiated below with a timeout threshold */
                                    onMouseDown={(event) => {

                                        this.mainModuleGroupDetailsDragHandleTimeoutMouseMightBeDragging = true;

                                        this.mainModuleGroupDetailsDragHandleTimeoutMouseMightBeDraggingEventTime = new Date();

                                        setTimeout(() => {
                                            if (this.mainModuleGroupDetailsDragHandleTimeoutMouseMightBeDragging === true) { // if the mouse is still down, treat as a drag
                                                this.setState({ mainModuleGroupDetailsIsDragging: true });
                                            } else {
                                                this.mainModuleGroupDetailsDragHandleTapHandler(event); // else treat as a click
                                            }
                                        }, 200); // a small delay to use with this.mainModuleGroupDetailsDragHandleMouseIsDown to differentiate onClick from onMouseDown
                                    }}

                                    onMouseUp={(event) => {
                                        if (this.mainModuleGroupDetailsDragHandleTimeoutMouseMightBeDragging) {
                                            const now = new Date();
                                            if (now.getTime() - this.mainModuleGroupDetailsDragHandleTimeoutMouseMightBeDraggingEventTime.getTime() > 200) {
                                                this.mainModuleGroupDetailsDragHandleTapHandler(event);
                                            }
                                        }
                                        this.mainModuleGroupDetailsDragHandleTimeoutMouseMightBeDragging = false;
                                    }}
                                >
                                    <i className="material-icons">drag_handle</i>
                                </button>
                            }
                        </div>
                        <div className="layout-main-module-group-details-eva-panel">
                            {this.props.mainModuleGroupDetailsEVAPanel}
                        </div>
                        {this.props.mainModuleGroupDetails}
                    </section>
                    :
                    null
                }


                {this.props.mainModuleGroupNavigation ?
                    <nav className={mainModuleGroupNavigationClass} style={mainModuleGroupNavigationDynamicStyles} onClick={this.setMainModuleGroupNavigationOnTop} onScroll={this.setMainModuleGroupNavigationOnTop} >
                        <button className="layout-main-module-group-navigation-disclosure-tab-bar" onClick={this.toggleModuleGroupNavigation}>
                            <div className="layout-main-module-group-navigation-disclosure-label">{this.props.mainModuleGroupNavigationTitle}</div>
                            <div className="layout-main-module-group-navigation-disclosure-icon">
                                <i className="material-icons">keyboard_arrow_up</i>
                            </div>
                        </button>
                        <div className="layout-main-module-group-navigation-wrapper">
                            {this.props.mainModuleGroupNavigation}
                        </div>
                    </nav>
                    :
                    null
                }
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    if (!state.data.layoutTemplateModularFullscreenSharedState) {
        console.error("LayoutTemplateModularFullscreen mapStateToProps layoutTemplateModularFullscreenSharedState reducer property not found");
        return {};
    }

    const { layoutTemplateModularFullscreenSharedState } = state.data;

    return {
        ...layoutTemplateModularFullscreenSharedState // shared between modular fullscreen group and the main and user menus
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        /*setMainNavigation: (isCollapsed) => {
            dispatch(dispatchActions.setMainNavigation(isCollapsed));
        },*/
        setMainModuleGroupNavigation: (isCollapsed) => {
            dispatch(dispatchActions.setMainModuleGroupNavigation(isCollapsed));
        },
        setMainModuleGroupDetails: (isCollapsed) => {
            dispatch(dispatchActions.setMainModuleGroupDetails(isCollapsed));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainModuleGroup);
